import { type ReactNode, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/CloseOutlined';

interface ModalProps {
    closeFn?: () => void;
    children: ReactNode;
    cssClasses?: string;
    maxWidth?: string;
}

const Modal = ({ children, closeFn, cssClasses = "", maxWidth }: ModalProps) => {
    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, []);

    const onClose = () => {
        if (closeFn) {
            closeFn?.();
        }
    };

    const style = maxWidth ? { maxWidth } : undefined;

    return (
        <div className={'modal modal--active ' + cssClasses}>
            <div className="modal__bck"></div>
            <div className="modal__main" style={style}>
                <div className="modal-main__hdr">
                    <button onClick={onClose} className="btn btn--close" aria-label="Close modal">
                        <CloseIcon aria-hidden="true" />
                    </button>
                </div>
                <div className="modal-main__content">{children}</div>
            </div>
        </div>
    );
};

export default Modal;
